"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebSocketClientFactory = void 0;
var subscriptions_transport_ws_1 = require("subscriptions-transport-ws");
/* eslint-disable class-methods-use-this */
var WebSocketClientFactory = /** @class */ (function () {
    function WebSocketClientFactory() {
    }
    WebSocketClientFactory.prototype.make = function (_a) {
        var headers = _a.headers, uri = _a.uri, webSocketClientOptions = _a.webSocketClientOptions;
        var wsProtocol = 'ws';
        if (typeof window !== 'undefined') {
            wsProtocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
        }
        var client = new subscriptions_transport_ws_1.SubscriptionClient(wsProtocol + ":" + uri, __assign({ reconnect: true, connectionParams: {
                headers: headers,
            } }, webSocketClientOptions));
        return client;
    };
    return WebSocketClientFactory;
}());
exports.WebSocketClientFactory = WebSocketClientFactory;
//# sourceMappingURL=WebSocketClientFactory.js.map